import { doRequest, HttpMethodEnum } from '../lib/httpHelper';
import { Service } from './service';

export default class DeliveryCostServic extends Service {

  async get(
    latitude: number,
    longitude: number,
    timestamp: number,
    order_type: 'asap' | 'preorder' | 'ecommerce' | 'horeca',
    amount: number,
  ) {
    return await doRequest({
      auth: false,
      url: `${this.root}v2/delivery-cost`,
      method: HttpMethodEnum.GET,
      params: { latitude, longitude, timestamp, order_type, amount },
    });
  }
}
